import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['itensforcount', 'totalcharacter']
  connect(){
    let charcontent = this.itensforcountTarget;
    this.totalcharacterTarget.innerHTML = charcontent.value.length + " / 150";
  }

  character() {
    let charcontent = this.itensforcountTarget;
    this.totalcharacterTarget.innerHTML = charcontent.value.length + " / 150";
  }
}
